<template>
  <ViewWrapper :scroll-steps="scrollSteps" class="add">
    <ScrollFade :scroll-position="scrollPosition" :min="0.4">
      <div class="add__stats_bg"></div>
    </ScrollFade>

    <ScrollFade class="add__global" :scroll-position="scrollPosition" :min="0.4">
      <h2>
        {{ $t('view.addToGlobe.sectionGlobalImpact.headline.your', { companyName }) }}<br />
        <b>{{ $t('view.addToGlobe.sectionGlobalImpact.headline.globalImpact') }}</b>
      </h2>
      <p>
        {{ $t('view.addToGlobe.sectionGlobalImpact.copy.remember') }}<br />
        {{ $t('view.addToGlobe.sectionGlobalImpact.copy.trace') }}
      </p>
      <Impact class="add__stats" :distribution="impactDistribution" />
    </ScrollFade>

    <ScrollFade class="add__copy" el="p" :scroll-position="scrollPosition" :max="0.4">
      {{ $t('view.addToGlobe.sectionAddedToGlobe.info') }}<br />
      <b>{{ $t('view.addToGlobe.sectionAddedToGlobe.impact') }}</b>
    </ScrollFade>

    <template #footer>
      <ScrollFade
        #default="{ id }"
        :scroll-position="scrollPosition"
        :min-max-map="{
          scrollhint: [{ max: 0.5 }],
          continue_button: [{ min: 0.6 }],
        }"
      >
        <!-- prevent overwrite of sub component animation -->
        <div v-if="id === 'scrollhint'">
          <InteractionHint
            class="add__scrollhint"
            :label="$t('ui.interactionHint.scroll')"
            icon="arrows-down"
            animation-class="moveUpDown"
            :interaction-timeout="2000"
            :interaction-trigger="scrollPosition"
          />
        </div>
        <div v-else-if="id === 'continue_button'">
          <ButtonPill class="add__continue_button" :to="{ name: 'companyDetail' }" replace>
            {{ $t('ui.continue') }}
          </ButtonPill>
        </div>
      </ScrollFade>
    </template>
  </ViewWrapper>
</template>

<script>
import store, { impactDistribution, getCompanyName } from '../store';

import { playSound } from '../services/sound';

import ButtonPill from '../components/ButtonPill';
import Impact from '../components/Chart/Impact';
import InteractionHint from '../components/InteractionHint';
import ScrollFade from '../components/ScrollFade';
import ViewWrapper from '../components/ViewWrapper';

const SCROLL_STEPS = 2;

export default {
  name: 'AddToGlobe',

  components: {
    ButtonPill,
    InteractionHint,
    Impact,
    ScrollFade,
    ViewWrapper,
  },

  props: {
    scrollPosition: {
      type: Number,
      default: undefined,
    },
  },

  data() {
    return {
      store,
      scrollSteps: SCROLL_STEPS,
    };
  },

  computed: {
    impactDistribution,
    companyName: getCompanyName,
  },

  watch: {
    scrollPosition(scrollPosition) {
      if (scrollPosition >= SCROLL_STEPS - 1) {
        store.setGlobeTransitionValue(1);
        // this.$router.push({ name: 'companyDetail' });
      } else {
        store.setGlobeTransitionValue(scrollPosition);
      }
    },
  },

  mounted() {
    window.scrollTo(0, 0);
    playSound('fxA', 'user');
  },
};
</script>

<style lang="scss" scoped>
.add {
  position: relative;
  text-align: center;

  ::v-deep {
    .view-wrapper__footer {
      z-index: 101;
    }
  }
}

.add__stats {
  @include transparent-layer();
}

.add__stats_bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  background-color: rgba($color-black, $view-overlay-alpha-dark);
  @include helper__box-shadow_overlap($color-black);
}

.add__global {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  max-width: $mobileDefaultMaxWidth;
  transform: translate(-50%, -50%);
  margin: 0;
  z-index: 100;

  h2 {
    @include font-headline;
    text-align: center;
    max-width: 320px;
    margin-left: auto;
    margin-right: auto;
    width: 320px;
  }
  p {
    line-height: 22px;
    margin-top: 10px;
    margin-bottom: 20px;
  }
}

.add__copy {
  position: absolute;
  left: 50%;
  bottom: 150px;
  transform: translateX(-50%);
  width: calc(100% - 20px * 2);

  h4 {
    font-size: inherit;
    margin-bottom: 5px;
  }

  p {
    line-height: 25px;
  }
}

.add__scrollhint {
  margin-bottom: calc(20px + env(safe-area-inset-bottom));
}

.add__continue_button {
  margin-bottom: calc(30px + env(safe-area-inset-bottom));
  z-index: 100;
}
</style>
